import type { ColumnConfig } from '@/components/datatable/dataTableTypes';
import type { PaginatedPrefilterTab } from '@/components/paginated-datatable/components/PaginatedDataTablePrefilterTabs.vue';
import type { PaginatedDataTableColumnConfig } from '@/components/paginated-datatable/types/paginatedDataTableTypes';
import type { ContractTypeV1Dto } from '@/openapi';

export const columns: PaginatedDataTableColumnConfig[] = [
  { field: 'actionStart', template: 'dateCell', sortable: true, hideInitial: true },
  { field: 'createdAt', template: 'dateCell', sortable: true, hideInitial: true },
  { field: 'definiteActionEnd', template: 'dateCell', sortable: true, hideInitial: true },
  { field: 'endDate', template: 'dateCell', sortable: true },
  { field: 'handOverDate', template: 'dateCell', sortable: true, hideInitial: true },
  { field: 'modifiedAt', template: 'dateCell', sortable: true, hideInitial: true },
  { field: 'name', sortable: true },
  { field: 'startDate', template: 'dateCell', sortable: true },
  { field: 'supposedActionEnd', template: 'dateCell', sortable: true, hideInitial: true },
  { field: 'id', hidden: true },
  { field: 'contractTypeId', hideInitial: true },
  { field: 'contractType', sortable: true },
  { field: 'nextPossibleContractEnd', template: 'dateCell', hideInitial: true },
  { field: 'lastPossibleContractEnd', template: 'dateCell', hideInitial: true },
  {
    field: 'areasToContracts',
    template: 'contractAreasArray',
    truncateLength: 1,
    hideInitial: true,
  },
  {
    field: 'contractClauses',
    template: 'contractClausesArray',
    truncateLength: 1,
    hideInitial: true,
  },
  {
    field: 'contractingParties',
    template: 'contractPartnersArray',
    truncateLength: 1,
    hideInitial: true,
  },
  {
    field: 'contractAction',
    template: 'contractActionArray',
    truncateLength: 1,
    hideInitial: true,
  },
  {
    field: 'contactPersonToContract',
    template: 'contractContactPersonsArray',
    truncateLength: 1,
    hideInitial: true,
  },
  {
    field: 'payments',
    template: 'contractPaymentsArray',
    truncateLength: 1,
    hideInitial: true,
  },
];

export const getContractsPrefilterTabs = (
  contractTypes: ContractTypeV1Dto[] | undefined,
  t: (key: string) => string,
): PaginatedPrefilterTab[] => [
  {
    title: 'labels.tabsAll',
    options: [{ title: 'labels.tabsAll', key: 'all' }],
  },
  ...(contractTypes?.length
    ? [
        {
          title: t('pages.contracts.tabs.contractType'),
          options: contractTypes.map((type) => ({
            title: t(`enums.${type.name.replace(/\s+/g, '_').toUpperCase()}`),
            key: type.id,
            focusedColumn: 'contractTypeId',
          })),
        } satisfies PaginatedPrefilterTab,
      ]
    : []),
  {
    title: 'pages.contracts.tabs.status:available',
    options: [
      {
        title: 'enums.AVAILABLE',
        key: 'actionsAvailable',
        focusedColumn: 'contractAction',
      },
    ],
  },
];

export const columnsV1: ColumnConfig[] = [
  { field: 'id', truncateLength: 8, noWrap: true, hidden: true },
  { field: 'name', truncateLength: 30 },
  { field: 'startDate', type: 'date' },
  { field: 'endDate', type: 'date', hideInitial: true },
  { field: 'contractTypeId', hideInitial: true },
  { field: 'contractType', type: 'enum' },
  { field: 'definiteActionEnd', type: 'date', hideInitial: true },
  { field: 'actionStart', type: 'date', hideInitial: true },
  { field: 'supposedActionEnd', type: 'date', hideInitial: true },
  { field: 'nextPossibleContractEnd', type: 'date', hideInitial: true },
  { field: 'lastPossibleContractEnd', type: 'date', hideInitial: true },
  {
    field: 'areasToContracts',
    type: 'array',
    template: 'contractAreasArray',
    truncateLength: 1,
    hideInitial: true,
  },
  {
    field: 'contractClauses',
    type: 'array',
    template: 'contractClausesArray',
    truncateLength: 1,
    hideInitial: true,
  },
  {
    field: 'contractingParties',
    type: 'array',
    truncateLength: 1,
    template: 'contractPartnersArray',
    hideInitial: true,
  },
  {
    field: 'contractAction',
    type: 'array',
    template: 'contractActionArray',
    truncateLength: 1,
    hideInitial: true,
  },
  {
    field: 'contactPersonToContract',
    type: 'array',
    template: 'contractContactPersonsArray',
    truncateLength: 1,
    hideInitial: true,
  },
  {
    field: 'payments',
    type: 'array',
    template: 'contractPaymentsArray',
    truncateLength: 1,
    hideInitial: true,
  },
];

export const contractWidgetColumns: ColumnConfig[] = [
  { field: 'id', truncateLength: 8, noWrap: true, hideInitial: true },
  { field: 'actionStart', type: 'date' },
  { field: 'supposedActionEnd', type: 'date' },
  { field: 'name', truncateLength: 30 },
  { field: 'contractType', type: 'enum' },
  {
    field: 'contractAction',
    type: 'array',
    template: 'contractActionByDate',
  },
];

export const documentOnContractColumns: ColumnConfig[] = [
  { field: 'id', truncateLength: 8, noWrap: true, hidden: true },
  { field: 'name' },
  { field: 'comment' },
];
